// extracted by mini-css-extract-plugin
export default {"galleryContainer":"CardImgGallery_galleryContainer__BDq1M"};